import { render, staticRenderFns } from "./ChoosePasswordForm.vue?vue&type=template&id=2972d76a&"
import script from "./ChoosePasswordForm.vue?vue&type=script&lang=js&"
export * from "./ChoosePasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePasswordForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports